import * as React from 'react';
import Modal from 'react-modal';
import './BusyModal.scss';

// styling for react-modal
const customStyles = {
  content: {
    width: 'auto',
    minWidth: '200px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0,0,0,0.7)',
    color: 'white',
  },
  overlay: {
    zIndex: '20',
  },
};

interface BusyModalProps {
  message?: string;
}

const BusyModal: React.FC<BusyModalProps> = (props: any) => {
  Modal.setAppElement('body');
  return (
    <Modal
      isOpen={props.message !== undefined && props.message !== ''}
      // onRequestClose={() => this.setState({ isOpen: false })}
      style={customStyles}
    // contentLabel="Example Modal"
    >
      <div className="busy-modal">
        {props.message ? <h3>{props.message}</h3> : null}
        <svg className="loader-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" />
        </svg>
      </div>
    </Modal>
  );
};
export default BusyModal;
